import { useMutation } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * Query key to track dealer bid template download mutation in react-query cache
 */
const DOWNLOAD_DEALER_BID_TEMPLATE_MUTATION_KEY =
  'download-dealer-bid-template-key';

interface IUseDownloadDealerBidTemplateMutationPayload {
  categoryId: string;
  brandId: string;
  onSuccess?: (fileData: BlobPart) => void;
}

/**
 * Hook to download dealer bid template excel for given category and brand.
 * @deprecated Use `useDownloadBidTemplateMutation` instead.
 */
export const useDownloadDealerBidTemplateMutation = ({
  categoryId,
  brandId,
  onSuccess,
}: IUseDownloadDealerBidTemplateMutationPayload) => {
  const { isPending, isError, error, data, mutate } = useMutation({
    mutationKey: [
      DOWNLOAD_DEALER_BID_TEMPLATE_MUTATION_KEY,
      categoryId,
      brandId,
    ],
    networkMode: 'always',
    mutationFn: () => BIDS_API.downloadDealerBidTemplate(brandId, categoryId),
    onSuccess,
  });

  return {
    error,
    isError,
    data,
    downloadDealerBidTemplate: mutate,
    isPending,
  };
};
